import { Component, OnInit, Signal } from '@angular/core'
import { TranslateModule } from '@ngx-translate/core'
import { NaturalStoneColorFiltersComponent } from '../natural-stone-color-filters/natural-stone-color-filters.component'
import { ApiService, UserInfo } from '../../../services/api.service'
import { NaturalStoneColor } from '../../../interfaces/natural-stone/natural-stone-color'
import { NaturalStoneService } from '../../../services/natural-stone.service'
import { NaturalStoneColorCardComponent } from '../natural-stone-color-card/natural-stone-color-card.component'
import { NgForOf, NgIf, UpperCasePipe } from '@angular/common'
import { LinkComponent } from '@components/link/link.component'
import { ButtonComponent } from '@components/button/button.component'
import { NaturalStoneMiniCartComponent } from '../natural-stone-mini-cart/natural-stone-mini-cart.component'
import { VirtualVisitService } from '../../../services/virtual-visit.service'
import { ConfirmModalComponent } from '@components/confirm-modal/confirm-modal.component'
import { NaturalStoneTutorialModalComponent } from '../natural-stone-tutorial-modal/natural-stone-tutorial-modal.component'

@Component({
  selector: 'app-natural-stone-color-list',
  standalone: true,
    imports: [
        TranslateModule,
        NaturalStoneColorFiltersComponent,
        NaturalStoneColorCardComponent,
        NgForOf,
        UpperCasePipe,
        LinkComponent,
        ButtonComponent,
        NaturalStoneMiniCartComponent,
        NgIf,
        ConfirmModalComponent,
        NaturalStoneTutorialModalComponent
    ],
  templateUrl: './natural-stone-color-list.component.html',
  styleUrl: './natural-stone-color-list.component.scss'
})
export class NaturalStoneColorListComponent implements OnInit{

    userInfo: UserInfo;
    colorList: Signal<NaturalStoneColor[]>
    tutorialModalOpen: boolean = false;
    canSelectVirtualVisit: boolean = false;

    constructor(private api: ApiService, private naturalStoneService: NaturalStoneService, private virtualVisitService: VirtualVisitService) {
        naturalStoneService.fetchColorList()
    }

    ngOnInit() {
        this.userInfo = this.api.userInfo.getValue()
        this.colorList = this.naturalStoneService.filteredColorList;
        this.canSelectVirtualVisit = this.virtualVisitService.canSelectVirtualVisit(this.userInfo)
    }

    showTutorial() {
        this.tutorialModalOpen = true;
    }

    openVirtualVisit() {
        this.virtualVisitService.goToVirtualVisit(this.userInfo)
    }

}
